import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ChangeDetectorRef } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {
  myProfile: any = true;
  aboutUsData: any = {};
  whyChooseItems = [
  {
    title: 'Innovative All-in-One Platform',
    description: 'Access every service your business needs under one roof.',
    icon: '/assets/images/aboutUs/group-10000019111.svg',
  },
  {
    title: 'Go Digital, Grow Faster',
    description: 'Transition to smarter, more efficient operations with our cutting-edge tools.',
    icon: '/assets/images/aboutUs/group-10000019151.svg',
  },
  {
    title: 'Quick Cost-Savings',
    description: 'Optimize costs and maximize profits with affordable, effective services.',
    icon: '/assets/images/aboutUs/group-10000019130.svg',
  },
  {
    title: 'Customized Solutions',
    description: 'Enjoy services tailored specifically to your unique business needs.',
    icon: '/assets/images/aboutUs/group-10000019140.svg',
  },
  {
    title: 'Backed by EFL’s Expertise',
    description: 'Benefit from over 30 years of industry knowledge and a proven track record.',
    icon: '/assets/images/aboutUs/group-10000019200.svg',
  },
  {
    title: 'Innovative All-in-One Platform',
    description: 'Access every service your business needs under one roof.',
    icon: '/assets/images/aboutUs/group-10000019111.svg',
  },
  {
    title: 'Go Digital, Grow Faster',
    description: 'Transition to smarter, more efficient operations with our cutting-edge tools.',
    icon: '/assets/images/aboutUs/group-10000019151.svg',
  },
  {
    title: 'Quick Cost-Savings',
    description: 'Optimize costs and maximize profits with affordable, effective services.',
    icon: '/assets/images/aboutUs/group-10000019130.svg',
  },
  {
    title: 'Customized Solutions',
    description: 'Enjoy services tailored specifically to your unique business needs.',
    icon: '/assets/images/aboutUs/group-10000019140.svg',
  },
  {
    title: 'Backed by EFL’s Expertise',
    description: 'Benefit from over 30 years of industry knowledge and a proven track record.',
    icon: '/assets/images/aboutUs/group-10000019200.svg',
  },
  // Add more objects for the other 3 cards...
];

our_leadershipItems = [
  {
    title: 'Shilpa Pophale',
    description: 'MD & CEO, Electronica Finance Ltd.',
    icon: '/assets/images/aboutUs/sp.png',
    url: 'https://www.linkedin.com/in/shilpa-pophale-a1b2214/?originalSubdomain=in'
  },
  {
    title: 'Ashutosh Puntambekar',
    description: 'Chief of Staff & Head, Sustainability',
    icon: '/assets/images/aboutUs/ap.png',
    url: 'https://www.linkedin.com/in/ashutosh-puntambekar-48727166/'
  },
  {
    title: 'Anshul Sharma',
    description: 'Business Head',
    icon: '/assets/images/aboutUs/bp.png',
    url: 'https://www.linkedin.com/in/anshulvas/'
  },
]

  constructor(
    private commonService: CommonService,
    private service: ApiServicesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // window.scrollTo(0, 0);  
    this.AboutUSAPIData();
    window.scrollTo(0, 0);
    this.cdr.detectChanges(); // ensure DOM is rendered
    this.initSlick(); 
  }

initSlick(): void {
  const slider = $('.featuredlistings-slide');

  if (slider.hasClass('slick-initialized')) {
    try {
      slider.slick('unslick');
    } catch (error) {
      console.warn('Slick unslick failed:', error);
    }
  }

  slider.slick({
    centerMode: true,
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.5, // default for desktop
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg" alt=""></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg" alt=""></button>',
    responsive: [
      {
        breakpoint: 1024, // Tablets
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          autoplay: true
        }
      },
      {
        breakpoint: 768, // Small tablets / landscape phones
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          autoplay: true
        }
      },
      {
        breakpoint: 480, // Mobile
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        }
      }
    ]
  });
}



  AboutUSAPIData() {
    const payload = {
      alias: 'about-us',
    };
    this.service.post(payload, API_ROUTES.AboutUsData.AboutUsDataList, {})
      .subscribe((res) => {
        if (res.success) {
          console.log("res.data", res.data);
          this.aboutUsData = res.data;
        } else {
          console.error('Failed to fetch FAQs', res.message);
        }
      }
      );
  }

  goBack() {
    this.commonService.goBack();
  }
}
